import React, { useEffect } from 'react';
import EditRequest from './EditRequest';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserRequest } from '../types/types';

const CreateRequest = () => {
  const { pointOfSale } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const duplicateRequest = (location.state as { duplicateRequest?: UserRequest })?.duplicateRequest;

  useEffect(() => {
    if (!pointOfSale) {
      navigate('/requests');
    }
  }, [pointOfSale, navigate]);

  return pointOfSale ? (
    <EditRequest 
      isCreating 
      pointOfSaleId={pointOfSale.id} 
      duplicateRequest={duplicateRequest}
    />
  ) : null;
};

export default CreateRequest; 